import { gql } from '@apollo/client';

export const CANDIDATE_TYPE_OF_PRACTICE_TEST = gql`
  query CANDIDATE_TYPE_PRACTICE_TEST($isB2C: Boolean!) {
    candidateType: candidateTypeOfPracticeTest(isB2C: $isB2C)
  }
`;
